import { render, staticRenderFns } from "./FacturaCreate.vue?vue&type=template&id=cf6e1c5c&scoped=true"
import script from "./FacturaCreate.vue?vue&type=script&lang=js"
export * from "./FacturaCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf6e1c5c",
  null
  
)

export default component.exports